
import { useState, useRef, useEffect } from "react";
import ProjectsLayout from "../Projects/ProjectsLayout";
import MusicLayout from "../Music/MusicLayout";


export default function MainContent () {

    const [active, setActive] = useState("");
      
    const sections = [
        { name: "Arthurlytics", ref: useRef() },
        { name: "CJI2", ref: useRef() },
        { name: "MENACE", ref: useRef() },
        { name: "Automata Tutor", ref: useRef() },
        { name: "Algorithms & Data Structures", ref: useRef() },
        { name: "Fallout Hotels", ref: useRef()},
        { name: "Corcovado", ref: useRef()},
        { name: "My Funny Valentine", ref: useRef()},
        { name: "April Come She Will", ref: useRef()},
        { name: "Mr Tambourine Man", ref: useRef()},
        { name: "One Too Many Mornings", ref: useRef()},
    ];


    useEffect(() => {
        const handleScroll = () => {
            let closest = ""; let minOffset = Number.POSITIVE_INFINITY;

            sections.forEach(({ name, ref }) => {
                if (ref.current) {
                    const offset = Math.abs(ref.current.getBoundingClientRect().top);
                    if (offset < minOffset) { minOffset = offset; closest = name; }
                }
            });
            setActive(closest);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        handleScroll(); 
        return () => window.removeEventListener("scroll", handleScroll);
    }, [sections]);

    return (
        <>
            <ProjectsLayout active={active} sections={sections} />
            <MusicLayout active={active} sections={sections} />
        </>
    )
}